import styled, { keyframes } from 'styled-components'

const dotsAnimation = keyframes`
  0% {
    content: '.';
  }
  25% {
    content: '..';
  }
  50% {
    content: '...';
  }
  75% {
    content: '..';
  }
  100% {
    content: '.';
  }
`

export const StyledLoadingDots = {
  Dots: styled.span`
    display: inline-block;
    width: 1.2em;
    text-align: left;

    &::after {
      content: '';
      animation: ${dotsAnimation} 1.5s steps(4, end) infinite;
    }
  `,
}
